import React from 'react';

export const QuadrantItem = ({ item, quadrant }) => {
    const energy_level = item.user_energy === 1 ? "text-always border-always" : item.user_energy === 3 && "text-never border-never";

    return (
        <>
            <div>
                <h6 className="mb-0 text-small text-nowrap font-weight-medium" id={quadrant.quadrant}>
                    {/* si es always tooglear clases 'text-always border-always'*/}
                    {/* si es sometimes tooglear clases 'text-white border-sometimes'*/}
                    {/* si es never tooglear clases 'text-never border-never'*/}
                    <i className={`icon d-inline-block mr-1 border rounded ${energy_level ? energy_level : 'text-white border-sometimes'}`}>
                        <svg width="8" height="8" className='d-block'><circle cx="4" cy="4" r="4" fill="currentColor"/></svg>
                    </i>
                    <span className="text-nowrap" style={{ lineHeight: '19px', paddingTop: '3px' }}>{item.name}</span>
                </h6>
            </div>
        </>
    )
}
